<div id="modal_white">
  <div class="row text-center modal_exit">
    <h2>Esci</h2>
    <div><p>Sei sicuro di volere uscire?</p></div>
    <button id="no_button" mat-raised-button (click)="modalClose()">Annulla</button>
    <button id="yes_button" mat-raised-button (click)="logout()">Conferma</button>
  </div>
</div>
